module.exports = __webpack_public_path__ + "img/Payments.5325f05a.svg";